import React, { createContext, useState, useContext, useEffect } from 'react';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

export const ScreenContext = createContext();

const ScreenContextProvider = (props) => {
    const theme = useTheme();
    const xs = useMediaQuery(theme.breakpoints.up('xs'));
    const sm = useMediaQuery(theme.breakpoints.up('sm'));
    const md = useMediaQuery(theme.breakpoints.up('md'));
    const lg = useMediaQuery(theme.breakpoints.up('lg'));
    const xl = useMediaQuery(theme.breakpoints.up('xl'));

    const [ screenSize, setScreenSize ] = useState('');
    const [ isMobile, setisMobile ] = useState(false)
    const [ isDesktop, setisDesktop ] = useState(false);

    // severity="error" severity="warning" severity="info" severity="success"
    const [snackbarMessage, setSnackbarMessage] = useState({ message: '', severity: ''}); 

    useEffect(()=>{

      if(xs) { setScreenSize('xs'); setisMobile(true); setisDesktop(false); }
      if(sm) { setScreenSize('sm'); setisMobile(true); setisDesktop(false); }
      if(md) { setScreenSize('md'); setisMobile(false); setisDesktop(true); }
      if(lg) { setScreenSize('lg'); setisMobile(false); setisDesktop(true); }
      if(xl) { setScreenSize('xl'); setisMobile(false); setisDesktop(true); }

    }, [xs,sm,md,lg,xl]);

    return (  
        <ScreenContext.Provider value={
            { 
              screenSize,
              snackbarMessage,
              isDesktop,
              isMobile,
              setSnackbarMessage
            }
        }>
            { props.children }
        </ScreenContext.Provider>        
    );
}
 
export default ScreenContextProvider;
